/**
 * @generated SignedSource<<ca302b0de1d9df67253ebadc09aac308>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TaskReportPage_viewer$data = {
  readonly actualPersonId: string | null;
  readonly id: string;
  readonly email: string | null;
  readonly company: {
    readonly customFieldDefinitionsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly key: string;
          readonly entityType: string;
          readonly displayName: string;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "TaskReportPage_viewer";
};
export type TaskReportPage_viewer$key = {
  readonly " $data"?: TaskReportPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskReportPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "customFieldDefinitionsV2"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      }
    ]
  },
  "name": "TaskReportPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": "customFieldDefinitionsV2",
          "args": null,
          "concreteType": "CustomFieldDefinitionV2TypeConnection",
          "kind": "LinkedField",
          "name": "__Company_customFieldDefinitionsV2_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomFieldDefinitionV2TypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "37ef18bcb9d656da586751edfae2c5ba";

export default node;
